import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from "@angular/core";
import { Subject } from "rxjs";
import { first } from "rxjs/operators";
import { BuildingSurveyViewModel } from "src/app/shared/Models/buildingTableViewModel";
import { AssignAddressToNewBuildingDTO } from "src/app/shared/Models/write/AssignAddressToNewBuildingDTO";
import {
  DialogService,
  DialogType,
} from "src/app/shared/services/dialog.service";
import { LoaderService } from "src/app/shared/services/loader.service";
import { TsaRemovalService } from "src/app/shared/tsa-removal.service";
import { BuildingService } from "../../../services/building.service";

@Component({
  selector: "app-reassign-option",
  templateUrl: "./reassign-option.component.html",
  styleUrls: ["./reassign-option.component.scss"],
})
export class ReassignOptionComponent implements OnDestroy {
  @Input() buildingSurveyVm: BuildingSurveyViewModel;
  @Input() allBuildingSurveyVms: BuildingSurveyViewModel[];

  @Output() closeReassignOption: Subject<{
    IsNewBuilding: boolean;
    lomkey?: number;
  }> = new Subject<{ IsNewBuilding: boolean; lomkey?: number }>();
  @Input() areaId: string;
  @Output() reloadBuildingList: EventEmitter<any> = new EventEmitter();
  assignToExistingBuilding: boolean = false;
  constructor(
    private buildingService: BuildingService,
    private dialogService: DialogService,
    private loaderService: LoaderService,
    private tsaRemovalService: TsaRemovalService
  ) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.loaderService.hide();
  }

  addToExistingBuilding() {
    this.assignToExistingBuilding = true;
  }

  onClose() {
    this.closeReassignOption.next({ IsNewBuilding: false });
  }

  innerReloadBuildingList() {
    this.reloadBuildingList.emit();
  }

  createNewBuilding() {
    var detailText = this.tsaRemovalService.getRemarkForBuildingSurveyViewModel(
      this.buildingSurveyVm,
      $localize`:@@buildinglist.createnewbuilding.detailtext:This action will create a new building, are you sure?`
    );

    this.dialogService
      .openDialog({
        headerText: $localize`:@@buildinglist.createnewbuilding.header:Create new building`,
        detailText: detailText,
        dialogType: DialogType.Continue,
      })
      .pipe(first())
      .subscribe((feedback) => {
        if (!feedback) return;

        this.loaderService.show();
        this.buildingService
          .assignAddressToNewBuilding(
            new AssignAddressToNewBuildingDTO({
              oldBuildingId: this.buildingSurveyVm.buildingId,
              addressId: this.buildingSurveyVm.addressId,
            })
          )
          .pipe(first())
          .subscribe(
            () => {
              this.closeReassignOption.next({ IsNewBuilding: true });
              this.innerReloadBuildingList();
            },
            () => {
              this.loaderService.hide();
            }
          );
      });
  }

  onCloseExistingBuilding() {
    this.assignToExistingBuilding = false;
    this.closeReassignOption.next({ IsNewBuilding: false });
  }
}
